import { useField, useFormikContext } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import { getRecaptchaSiteKey } from "../../utils/recaptcha";

const RecaptchaInput = ({
  name,
  size = "normal",
  theme = "light",
  onExpired,
  onError,
  onSuccess,
}) => {
  const { setFieldValue } = useFormikContext();
  const [_field, meta] = useField(name);
  const recaptchaRef = useRef(null);
  const siteKey = getRecaptchaSiteKey();

  const handleChange = (value) => {
    setFieldValue(name, value);
    // Clear any previous errors when user completes reCAPTCHA
    if (value && meta.error) {
      setFieldValue(name, value, true); // Trigger validation
    }

    // Call success callback if provided
    if (value && onSuccess) {
      onSuccess(value);
    }
  };

  const handleExpired = () => {
    setFieldValue(name, null);
    if (onExpired) {
      onExpired();
    }
  };

  const handleError = (error) => {
    setFieldValue(name, null);
    console.error("reCAPTCHA error:", error);
    if (onError) {
      onError(error);
    }
  };

  return (
    <div style={{ marginBottom: "1rem" }}>
      <ReCAPTCHA
        ref={recaptchaRef}
        style={{ display: "inline-block" }}
        sitekey={siteKey}
        size={size}
        theme={theme}
        onChange={handleChange}
        onExpired={handleExpired}
        onError={handleError}
      />

      <div style={{ display: "block" }}>
        {meta.error ? (
          <span style={{ color: "red", fontSize: "12px", width: "100%" }}>
            {meta.error}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default RecaptchaInput;
